import React from "react";

import { CaptureSettingsSection } from "./CaptureSettingsSection/CaptureSettingsSection";
import "./DriverAppTab.scss";

export function DriverAppTab() {
  return (
    <div className="tab-content driver-app-tab">
      <div className="da-header">
        <h2>Driver App</h2>
        <p className="da-subtitle">
          Control driver-app behavior for in-progress jobs.
        </p>
      </div>

      <CaptureSettingsSection />
    </div>
  );
}
